module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/multiple-properties-location-75326918456ae23e009001fb8364e69a.svg";